import './watchPathNameChange'
import './watchLinkExt'
import {ym} from './ym'
import {getAnalyticsId} from './getAnalyticsId'
import {getEnv} from '../shared/env'
import {sessionStore} from '../shared/SessionStore'

sessionStore.onDataChange(() => {
  ym(getAnalyticsId(), 'params', {
    requestId: sessionStore.data.requestId,
    sessionId: sessionStore.data.sessionId,
    parentRequestId: sessionStore.data.parentRequestId,
    partnerId: sessionStore.data.partnerId
  })
})

try {
  debug('script_load_start')

  if (getEnv().LOGGER_DISABLE_METRIKA) {
    throw 'skip_metrika_init_by_env'
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.crossOrigin = 'anonymous'

  const domain = window.location.hostname.endsWith('.ru') ? 'ru' : 'com'
  script.src = `https://mc.yandex.${domain}/metrika/tag.js`
  debug('script_load_src', script.src)

  script.addEventListener('error', (error) => debug('script_load_error', error))
  script.addEventListener('load', () => debug('script_load_success'))

  debug('script_append')

  document.head.append(script)

  deferredInit()
} catch (error) {
  debug('load_error', error)
}

function initAnalytics(id: number) {
  return new Promise<void>((resolve) => {
    debug(`counter_init_start`, id)

    const timeoutId = setTimeout(() => {
      debug(`counter_init_timeout [5s]`, id)
    }, 5_000)

    window.document.addEventListener(
      `yacounter${id}inited`,
      () => {
        resolve()
        clearTimeout(timeoutId)
        debug(`counter_init_success`, id)
      },
      {once: true}
    )

    // https://yandex.ru/support/metrica/code/counter-spa-setup.html
    ym(id, 'init', {
      defer: true,
      triggerEvent: true,
      trackLinks: true,
      trackHash: false,
      // TODO: можно включить, но потом, что бы если что отследить влияение на креши и прочее
      // а еще чтобы записывать экран надо с него выпиливать перс. данные как то
      webvisor: false,
      clickmap: false // TODO: EDARESTAPP-8515
    })
  })
}

function deferredInit() {
  const isProtected = () =>
    ['/handle-redirect', '/transfer-data', '/oauth-token', '/promotion/oauth-callback'].includes(
      window.location.pathname
    )

  if (!isProtected()) {
    debug(`immediate_init_start`)
    initAnalytics(getAnalyticsId())
    return
  }

  debug(`deferred_init_start`)
  window.addEventListener(
    'oauthcomplete',
    () => {
      if (!isProtected()) {
        debug(`deferred_init_end`)
        initAnalytics(getAnalyticsId())
        return
      }

      const intervalId = setInterval(() => {
        if (isProtected()) {
          debug(`deferred_init_retry`)
          return
        }

        debug(`deferred_init_end`)
        clearInterval(intervalId)
        initAnalytics(getAnalyticsId())
      }, 1_000)
    },
    {once: true}
  )
}

function debug(...rest: unknown[]) {
  console.debug(`[metrika] [${new Date().toISOString()}]:`, ...rest)
}
